import { render } from "./SignupScreen.vue?vue&type=template&id=fbbcca08&scoped=true"
import script from "./SignupScreen.vue?vue&type=script&lang=js"
export * from "./SignupScreen.vue?vue&type=script&lang=js"

import "./SignupScreen.vue?vue&type=style&index=0&id=fbbcca08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbcca08"]])

export default __exports__